import { render, staticRenderFns } from "./CommentModal.vue?vue&type=template&id=26866d16&scoped=true&"
import script from "./CommentModal.vue?vue&type=script&lang=js&"
export * from "./CommentModal.vue?vue&type=script&lang=js&"
import style0 from "./CommentModal.vue?vue&type=style&index=0&id=26866d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26866d16",
  null
  
)

export default component.exports